export default (analyticsCookies, marketingCookies) => {
  // console.log('ga', { analyticsCookies, marketingCookies });
  if (window.gtag) {
    window.gtag('consent', 'update', {
      ad_storage: marketingCookies ? 'granted' : 'denied',
      analytics_storage: analyticsCookies ? 'granted' : 'denied',
      ad_user_data: marketingCookies ? 'granted' : 'denied',
      ad_personalization: marketingCookies ? 'granted' : 'denied',

    });
  }
};
